import styled from 'styled-components';
import { theme, palette } from 'styled-tools';

interface Props { }

export const TextArea = styled.textarea<Props>`
    resize: none;
    width: 100%;
    height: 186px;
    border: 1px solid ${palette('gray_opacity_100')};
    box-sizing: border-box;
    border-radius: 8px;
    padding: 16px 20px;

    /* IE10 이상을 위한 css */
    &:placeholder {
        color: ${palette('gray_opacity_600')};
        ${theme('fontStyle.body2')}
        opacity: 1;
    }

    &:-webkit-input-placeholder {
        color: ${palette('gray_opacity_600')};
        ${theme('fontStyle.body2')}
    }
    /* IE */
    &:-ms-input-placeholder {
        color: ${palette('gray_opacity_600')};
        ${theme('fontStyle.body2')}
    }
    /* Firefox */
    &::-mos-input-placeholder {
        color: ${palette('gray_opacity_600')};
        ${theme('fontStyle.body2')}
    }
`;
